import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dfd3f1a2")

_pushScopeId("data-v-dfd3f1a2")
const _hoisted_1 = {
  novalidate: "",
  id: "providerDetailsForm"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  class: "default-card-header collapsed",
  id: "headingPersonalDetails",
  "data-toggle": "collapse",
  "data-target": "#providerPersonalDetails"
}
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerPersonalDetails"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_7 = {
  id: "providerPersonalDetails",
  class: "collapse",
  "aria-labelledby": "headingPersonalDetails",
  "data-parent": "#accordionProvider"
}
const _hoisted_8 = { class: "card-body default-card-body" }
const _hoisted_9 = { class: "several-section" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "default-title" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_14 = {
  key: 0,
  class: "default-text"
}
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "default-text"
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "default-title" }
const _hoisted_20 = { class: "default-text" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "default-title" }
const _hoisted_24 = { class: "default-text" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "default-title" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_29 = {
  key: 0,
  class: "default-text"
}
const _hoisted_30 = { class: "invalid-feedback" }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "default-text"
}
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "default-title" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_36 = {
  key: 0,
  class: "default-text"
}
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "default-text"
}
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "default-title" }
const _hoisted_42 = {
  key: 0,
  class: "default-text"
}
const _hoisted_43 = {
  key: 1,
  class: "default-text"
}
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "default-title" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_47 = {
  key: 0,
  class: "default-text"
}
const _hoisted_48 = { class: "invalid-feedback" }
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_50 = {
  key: 1,
  class: "default-text"
}
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "default-title" }
const _hoisted_53 = {
  key: 0,
  class: "default-text"
}
const _hoisted_54 = {
  key: 1,
  class: "default-text"
}
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "default-title" }
const _hoisted_57 = {
  key: 0,
  class: "default-text"
}
const _hoisted_58 = {
  key: 1,
  class: "default-text"
}
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "default-title" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_62 = {
  key: 0,
  class: "default-text"
}
const _hoisted_63 = { class: "invalid-feedback" }
const _hoisted_64 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_65 = {
  key: 1,
  class: "default-text"
}
const _hoisted_66 = { class: "col-md-6" }
const _hoisted_67 = { class: "default-title" }
const _hoisted_68 = {
  key: 0,
  class: "default-text"
}
const _hoisted_69 = {
  key: 1,
  class: "default-text"
}
const _hoisted_70 = { class: "" }
const _hoisted_71 = { class: "default-title" }
const _hoisted_72 = {
  key: 0,
  class: "default-text"
}
const _hoisted_73 = {
  key: 1,
  class: "default-text"
}
const _hoisted_74 = { class: "" }
const _hoisted_75 = { class: "default-title" }
const _hoisted_76 = {
  key: 0,
  class: "default-text"
}
const _hoisted_77 = {
  key: 1,
  class: "default-text"
}
const _hoisted_78 = { class: "" }
const _hoisted_79 = { class: "default-title" }
const _hoisted_80 = {
  key: 0,
  class: "default-text"
}
const _hoisted_81 = {
  key: 1,
  class: "default-text"
}
const _hoisted_82 = { class: "" }
const _hoisted_83 = { class: "default-title" }
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_85 = {
  key: 0,
  class: "default-text"
}
const _hoisted_86 = {
  key: 0,
  class: "multy-invalid-feedback"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-error fs-16 pr4" }, null, -1)
const _hoisted_88 = {
  key: 1,
  class: "default-text"
}
const _hoisted_89 = { class: "several-section" }
const _hoisted_90 = { class: "" }
const _hoisted_91 = { class: "default-title" }
const _hoisted_92 = {
  key: 0,
  class: "default-text"
}
const _hoisted_93 = {
  key: 1,
  class: "default-text"
}
const _hoisted_94 = { class: "" }
const _hoisted_95 = { class: "default-title" }
const _hoisted_96 = {
  key: 0,
  class: "logo-container"
}
const _hoisted_97 = { class: "flex-grow-1 d-flex" }
const _hoisted_98 = {
  key: 0,
  class: "icon-f icon-pencil-edit fs-12"
}
const _hoisted_99 = {
  key: 1,
  class: "icon-f icon-plus fs-12"
}
const _hoisted_100 = {
  key: 1,
  class: "default-text"
}
const _hoisted_101 = { class: "card" }
const _hoisted_102 = {
  class: "default-card-header collapsed",
  id: "headingOperationContacts",
  "data-toggle": "collapse",
  "data-target": "#providerOperationContacts"
}
const _hoisted_103 = { class: "mb-0" }
const _hoisted_104 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerOperationContacts"
}
const _hoisted_105 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_106 = {
  id: "providerOperationContacts",
  class: "collapse",
  "aria-labelledby": "headingOperationContacts",
  "data-parent": "#accordionProvider"
}
const _hoisted_107 = { class: "card-body default-card-body" }
const _hoisted_108 = { class: "several-section" }
const _hoisted_109 = { class: "" }
const _hoisted_110 = { class: "default-title" }
const _hoisted_111 = {
  key: 0,
  class: "default-text"
}
const _hoisted_112 = {
  key: 1,
  class: "default-text"
}
const _hoisted_113 = { class: "row" }
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = { class: "default-title" }
const _hoisted_116 = {
  key: 0,
  class: "default-text"
}
const _hoisted_117 = {
  key: 1,
  class: "default-text"
}
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = { class: "default-title" }
const _hoisted_120 = {
  key: 0,
  class: "default-text"
}
const _hoisted_121 = {
  key: 1,
  class: "default-text"
}
const _hoisted_122 = { class: "card" }
const _hoisted_123 = {
  class: "default-card-header collapsed",
  id: "headingFinanceDepartment",
  "data-toggle": "collapse",
  "data-target": "#providerFinanceDepartment"
}
const _hoisted_124 = { class: "mb-0" }
const _hoisted_125 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerFinanceDepartment"
}
const _hoisted_126 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_127 = {
  id: "providerFinanceDepartment",
  class: "collapse",
  "aria-labelledby": "headingFinanceDepartment",
  "data-parent": "#accordionProvider"
}
const _hoisted_128 = { class: "card-body default-card-body" }
const _hoisted_129 = { class: "several-section" }
const _hoisted_130 = { class: "" }
const _hoisted_131 = { class: "default-title" }
const _hoisted_132 = {
  key: 0,
  class: "default-text"
}
const _hoisted_133 = {
  key: 1,
  class: "default-text"
}
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { class: "col-md-6" }
const _hoisted_136 = { class: "default-title" }
const _hoisted_137 = {
  key: 0,
  class: "default-text"
}
const _hoisted_138 = {
  key: 1,
  class: "default-text"
}
const _hoisted_139 = { class: "col-md-6" }
const _hoisted_140 = { class: "default-title" }
const _hoisted_141 = {
  key: 0,
  class: "default-text"
}
const _hoisted_142 = {
  key: 1,
  class: "default-text"
}
const _hoisted_143 = {
  key: 0,
  class: "card"
}
const _hoisted_144 = {
  class: "default-card-header collapsed",
  id: "headingProfiles",
  "data-toggle": "collapse",
  "data-target": "#providerProfiles"
}
const _hoisted_145 = { class: "mb-0" }
const _hoisted_146 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerProfiles"
}
const _hoisted_147 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_148 = {
  id: "providerProfiles",
  class: "collapse",
  "aria-labelledby": "providerProfiles",
  "data-parent": "#accordionProvider"
}
const _hoisted_149 = { class: "card-body default-card-body" }
const _hoisted_150 = { class: "several-section" }
const _hoisted_151 = {
  key: 1,
  class: "card"
}
const _hoisted_152 = {
  class: "default-card-header collapsed",
  id: "headingUsers",
  "data-toggle": "collapse",
  "data-target": "#providerUsers"
}
const _hoisted_153 = { class: "mb-0" }
const _hoisted_154 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerUsers"
}
const _hoisted_155 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_156 = {
  id: "providerUsers",
  class: "collapse",
  "aria-labelledby": "headingUsers",
  "data-parent": "#accordionProvider"
}
const _hoisted_157 = { class: "card-body default-card-body" }
const _hoisted_158 = { class: "several-section" }
const _hoisted_159 = { class: "card" }
const _hoisted_160 = {
  class: "default-card-header collapsed",
  id: "headingAccounting",
  "data-toggle": "collapse",
  "data-target": "#providerAccounting"
}
const _hoisted_161 = { class: "mb-0" }
const _hoisted_162 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerAccounting"
}
const _hoisted_163 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_164 = {
  id: "providerAccounting",
  class: "collapse",
  "aria-labelledby": "providerAccounting",
  "data-parent": "#accordionProvider"
}
const _hoisted_165 = { class: "card-body default-card-body" }
const _hoisted_166 = { class: "several-section" }
const _hoisted_167 = { class: "card" }
const _hoisted_168 = {
  class: "default-card-header collapsed",
  id: "headingOrderSettings",
  "data-toggle": "collapse",
  "data-target": "#providerOrderSettings"
}
const _hoisted_169 = { class: "mb-0" }
const _hoisted_170 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "providerOrderSettings"
}
const _hoisted_171 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_172 = {
  id: "providerOrderSettings",
  class: "collapse",
  "aria-labelledby": "providerOrderSettings",
  "data-parent": "#accordionProvider"
}
const _hoisted_173 = { class: "card-body default-card-body" }
const _hoisted_174 = { class: "several-section" }
const _hoisted_175 = { class: "row" }
const _hoisted_176 = { class: "col-md-6 d-grid" }
const _hoisted_177 = { class: "default-title" }
const _hoisted_178 = {
  key: 0,
  class: "align-self-end"
}
const _hoisted_179 = {
  key: 0,
  class: "default-text"
}
const _hoisted_180 = {
  key: 1,
  class: "default-text"
}
const _hoisted_181 = { class: "col-md-6" }
const _hoisted_182 = { class: "default-title" }
const _hoisted_183 = { key: 0 }
const _hoisted_184 = {
  key: 0,
  class: "default-text"
}
const _hoisted_185 = {
  key: 1,
  class: "default-text"
}
const _hoisted_186 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_187 = { class: "default-title" }
const _hoisted_188 = { key: 0 }
const _hoisted_189 = {
  key: 0,
  class: "default-text"
}
const _hoisted_190 = {
  key: 1,
  class: "default-text"
}
const _hoisted_191 = { class: "default-title" }
const _hoisted_192 = { key: 0 }
const _hoisted_193 = {
  key: 0,
  class: "default-text"
}
const _hoisted_194 = {
  key: 1,
  class: "default-text"
}
const _hoisted_195 = { class: "default-title" }
const _hoisted_196 = { key: 0 }
const _hoisted_197 = {
  key: 0,
  class: "default-text"
}
const _hoisted_198 = {
  key: 1,
  class: "default-text"
}
const _hoisted_199 = { class: "col-md-6 order5" }
const _hoisted_200 = { class: "default-title" }
const _hoisted_201 = { key: 0 }
const _hoisted_202 = {
  key: 0,
  class: "default-text"
}
const _hoisted_203 = {
  key: 1,
  class: "default-text"
}
const _hoisted_204 = { class: "col-md-6 order6" }
const _hoisted_205 = { class: "default-title" }
const _hoisted_206 = { key: 0 }
const _hoisted_207 = {
  key: 0,
  class: "default-text"
}
const _hoisted_208 = {
  key: 1,
  class: "default-text"
}
const _hoisted_209 = { class: "several-section" }
const _hoisted_210 = { class: "row" }
const _hoisted_211 = {
  key: 0,
  class: "col-12 text-center pt-4"
}
const _hoisted_212 = {
  key: 1,
  class: "col-12 text-center"
}
const _hoisted_213 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_214 = {
  key: 2,
  class: "col-12 default-title pt-4"
}
const _hoisted_215 = { class: "source-option" }
const _hoisted_216 = { class: "pb-1" }
const _hoisted_217 = { key: 1 }
const _hoisted_218 = {
  key: 2,
  class: "card"
}
const _hoisted_219 = {
  class: "default-card-header collapsed",
  id: "headingProfiles",
  "data-toggle": "collapse",
  "data-target": "#notoficationsRestrictions"
}
const _hoisted_220 = { class: "mb-0" }
const _hoisted_221 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "false",
  "aria-controls": "notoficationsRestrictions"
}
const _hoisted_222 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_223 = {
  id: "notoficationsRestrictions",
  class: "collapse",
  "aria-labelledby": "notoficationsRestrictions",
  "data-parent": "#accordionProvider"
}
const _hoisted_224 = { class: "card-body default-card-body" }
const _hoisted_225 = { class: "several-section" }
const _hoisted_226 = { class: "card" }
const _hoisted_227 = {
  class: "default-card-header collapsed",
  id: "headingSubscription",
  "data-toggle": "collapse",
  "data-target": "#providerSubscription"
}
const _hoisted_228 = { class: "mb-0" }
const _hoisted_229 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "true",
  "aria-controls": "providerSubscription"
}
const _hoisted_230 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_231 = {
  id: "providerSubscription",
  class: "collapse",
  "aria-labelledby": "headingSubscription",
  "data-parent": "#accordionProvider"
}
const _hoisted_232 = { class: "card-body default-card-body" }
const _hoisted_233 = { class: "several-section overflow-auto" }
const _hoisted_234 = { class: "row" }
const _hoisted_235 = { class: "col-md-6" }
const _hoisted_236 = { class: "default-title" }
const _hoisted_237 = /*#__PURE__*/_createVNode("span", { class: "furry-point" }, "*", -1)
const _hoisted_238 = {
  key: 0,
  class: "default-text"
}
const _hoisted_239 = {
  key: 0,
  class: "error-validation pt-1"
}
const _hoisted_240 = {
  key: 1,
  class: "default-text"
}
const _hoisted_241 = { class: "col-md-6" }
const _hoisted_242 = { class: "default-title" }
const _hoisted_243 = { class: "default-text" }
const _hoisted_244 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_245 = { class: "default-title" }
const _hoisted_246 = { class: "default-text m-0" }
const _hoisted_247 = {
  key: 1,
  class: "col-md-6 d-flex align-items-center"
}
const _hoisted_248 = { class: "default-title" }
const _hoisted_249 = { class: "mx-2" }
const _hoisted_250 = {
  key: 1,
  class: "default-text provider-status desktop"
}
const _hoisted_251 = {
  key: 0,
  class: "status-green"
}
const _hoisted_252 = {
  key: 1,
  class: "status-red"
}
const _hoisted_253 = { class: "col-md-6" }
const _hoisted_254 = { class: "default-title after-colon" }
const _hoisted_255 = { class: "mx-2" }
const _hoisted_256 = {
  key: 1,
  class: "default-text provider-status desktop"
}
const _hoisted_257 = { class: "default-title after-colon" }
const _hoisted_258 = {
  key: 0,
  class: "status-green"
}
const _hoisted_259 = {
  key: 1,
  class: "status-red"
}
const _hoisted_260 = { class: "default-text provider-status mobile" }
const _hoisted_261 = {
  key: 0,
  class: "status-green"
}
const _hoisted_262 = {
  key: 1,
  class: "status-red"
}
const _hoisted_263 = { class: "card" }
const _hoisted_264 = {
  class: "default-card-header collapsed",
  id: "headingСashierStation",
  "data-toggle": "collapse",
  "data-target": "#providerСashierStation"
}
const _hoisted_265 = { class: "mb-0" }
const _hoisted_266 = {
  class: "btn btn-link",
  type: "button",
  "aria-expanded": "true",
  "aria-controls": "providerСashierStation"
}
const _hoisted_267 = /*#__PURE__*/_createVNode("i", { class: "arrow float-right" }, null, -1)
const _hoisted_268 = {
  id: "providerСashierStation",
  class: "collapse",
  "aria-labelledby": "headingСashierStation",
  "data-parent": "#accordionProvider"
}
const _hoisted_269 = { class: "card-body default-card-body" }
const _hoisted_270 = { class: "several-section" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Profiles = _resolveComponent("Profiles")
  const _component_Users = _resolveComponent("Users")
  const _component_Accounting = _resolveComponent("Accounting")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_NotificationsRestrictions = _resolveComponent("NotificationsRestrictions")
  const _component_cashierStations = _resolveComponent("cashierStations")

  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("div", {
      class: ["accordion", { providerEdit: _ctx.editMode }],
      id: "accordionProvider"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h5", _hoisted_4, [
            _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t('providers.personal.title')), 1)
          ]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.name')) + ": ", 1),
                    _hoisted_13
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              required: "",
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.provider.name = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.name]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(_ctx.provider.name), 1))
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('providers.personal.hash')) + ":", 1),
                  _createVNode("div", _hoisted_20, [
                    (_ctx.provider.hash)
                      ? (_openBlock(), _createBlock("span", _hoisted_21, _toDisplayString(_ctx.provider.hash), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('providers.personal.id')) + ":", 1),
                  _createVNode("div", _hoisted_24, [
                    (_ctx.provider.id)
                      ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.provider.id), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.companyName')) + ": ", 1),
                    _hoisted_28
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_29, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              required: "",
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.provider.companyName = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.companyName]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_32, _toDisplayString(_ctx.provider.companyName), 1))
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.companyId')) + ": ", 1),
                    _hoisted_35
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_36, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              required: "",
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.provider.companyId = $event)),
                              maxlength: "14",
                              onKeypress: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 544)), [
                              [_vModelText, _ctx.provider.companyId]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_37, [
                          _hoisted_38,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(_ctx.provider.companyId), 1))
                ]),
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('providers.personal.invoiceName')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_42, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.provider.nameOfTheBusinessForInvoice = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.nameOfTheBusinessForInvoice]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_43, _toDisplayString(_ctx.provider.nameOfTheBusinessForInvoice), 1))
                ]),
                _createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.email')) + ": ", 1),
                    _hoisted_46
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_47, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              required: "",
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.provider.email = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.email]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_48, [
                          _hoisted_49,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_50, _toDisplayString(_ctx.provider.email), 1))
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('providers.personal.crmId')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_53, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.provider.crmId = $event)),
                              maxlength: "12",
                              onKeypress: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 544)), [
                              [_vModelText, _ctx.provider.crmId]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_54, _toDisplayString(_ctx.provider.crmId), 1))
                ]),
                _createVNode("div", _hoisted_55, [
                  _createVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('providers.personal.ytourId')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_57, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.provider.ytourId = $event)),
                              maxlength: "12",
                              onKeypress: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isNumber($event)))
                            }, null, 544)), [
                              [_vModelText, _ctx.provider.ytourId]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_58, _toDisplayString(_ctx.provider.ytourId), 1))
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.mobile')) + ": ", 1),
                    _hoisted_61
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_62, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              required: "",
                              type: "text",
                              class: ["bookit-input form-control", { 'is-invalid': _ctx.invalidMobile }],
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.provider.mobile = $event))
                            }, null, 2)), [
                              [_vModelText, _ctx.provider.mobile]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("span", _hoisted_63, [
                          _hoisted_64,
                          _createTextVNode(" " + _toDisplayString(_ctx.invalidMobile ? _ctx.$t('novalid.input.mobile') : _ctx.$t('valid.isRequired')), 1)
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_65, _toDisplayString(_ctx.provider.mobile), 1))
                ]),
                _createVNode("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, _toDisplayString(_ctx.$t('providers.personal.virtualPhoneNumber')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_68, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.provider.virtualPhoneNumber = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.virtualPhoneNumber]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_69, _toDisplayString(_ctx.provider.virtualPhoneNumber), 1))
                ])
              ]),
              _createVNode("div", _hoisted_70, [
                _createVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('providers.personal.address')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_72, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.provider.address = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.address]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_73, _toDisplayString(_ctx.provider.address), 1))
              ]),
              _createVNode("div", _hoisted_74, [
                _createVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('providers.personal.website')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_76, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.provider.website = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.website]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_77, _toDisplayString(_ctx.provider.website), 1))
              ]),
              _createVNode("div", _hoisted_78, [
                _createVNode("div", _hoisted_79, _toDisplayString(_ctx.$t('providers.personal.policy')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_80, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.provider.policy = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.policy]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_81, _toDisplayString(_ctx.provider.policy), 1))
              ]),
              _createVNode("div", _hoisted_82, [
                _createVNode("div", _hoisted_83, [
                  _createTextVNode(_toDisplayString(_ctx.$t('providers.personal.smsEmailLanguage')) + ": ", 1),
                  _hoisted_84
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_85, [
                      _createVNode(_component_Multiselect, _mergeProps({
                        required: "",
                        class: { 'form-controll-multiselect': !_ctx.provider.smsEmailLanguageId }
                      }, _ctx.langsSelect, {
                        modelValue: _ctx.provider.smsEmailLanguageId,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.provider.smsEmailLanguageId = $event))
                      }), null, 16, ["class", "modelValue"]),
                      (!_ctx.provider.smsEmailLanguageId)
                        ? (_openBlock(), _createBlock("span", _hoisted_86, [
                            _hoisted_87,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('valid.isRequired')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_88, _toDisplayString(_ctx.getLangName(_ctx.provider.smsEmailLanguageId)), 1))
              ])
            ]),
            _createVNode("div", _hoisted_89, [
              _createVNode("div", _hoisted_90, [
                _createVNode("div", _hoisted_91, _toDisplayString(_ctx.$t('providers.personal.description')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_92, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("textarea", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.provider.description = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.description]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_93, _toDisplayString(_ctx.provider.description), 1))
              ]),
              _createVNode("div", _hoisted_94, [
                _createVNode("div", _hoisted_95, _toDisplayString(_ctx.$t('providers.personal.logo')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_96, [
                      _createVNode("div", _hoisted_97, [
                        _createVNode("img", {
                          height: "65",
                          src: _ctx.providerLogo || _ctx.provider.mainImageUrl,
                          alt: ""
                        }, null, 8, ["src"]),
                        (_ctx.providerLogo || _ctx.provider.mainImageUrl)
                          ? (_openBlock(), _createBlock("i", {
                              key: 0,
                              class: "icon-f icon-delete-cross fs-10 px-2 py-1 align-self-start",
                              style: {"color":"#475472"},
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("label", {
                        class: ["btn-secondary", { 'mx-2': _ctx.providerLogo || _ctx.provider.mainImageUrl }]
                      }, [
                        _createVNode("input", {
                          type: "file",
                          name: "",
                          id: "image-upload-input",
                          style: {"display":"none"},
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.uploadingImageValidation && _ctx.uploadingImageValidation(...args))),
                          accept: "image/png"
                        }, null, 32),
                        (_ctx.providerLogo || _ctx.provider.mainImageUrl)
                          ? (_openBlock(), _createBlock("i", _hoisted_98))
                          : (_openBlock(), _createBlock("i", _hoisted_99))
                      ], 2)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_100, [
                      (_ctx.provider.mainImageUrl)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.provider.mainImageUrl,
                            alt: "",
                            height: "65"
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_101, [
        _createVNode("div", _hoisted_102, [
          _createVNode("h5", _hoisted_103, [
            _createVNode("button", _hoisted_104, _toDisplayString(_ctx.$t('providers.operation.title')), 1)
          ]),
          _hoisted_105
        ]),
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _createVNode("div", _hoisted_109, [
                _createVNode("div", _hoisted_110, _toDisplayString(_ctx.$t('providers.operation.name')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_111, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.provider.operationContactFullName = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.operationContactFullName]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_112, _toDisplayString(_ctx.provider.operationContactFullName), 1))
              ]),
              _createVNode("div", _hoisted_113, [
                _createVNode("div", _hoisted_114, [
                  _createVNode("div", _hoisted_115, _toDisplayString(_ctx.$t('providers.operation.email')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_116, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.provider.operationContactEmail = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.operationContactEmail]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_117, _toDisplayString(_ctx.provider.operationContactEmail), 1))
                ]),
                _createVNode("div", _hoisted_118, [
                  _createVNode("div", _hoisted_119, _toDisplayString(_ctx.$t('providers.operation.mobile')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_120, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.provider.operationContactPhoneNumber = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.operationContactPhoneNumber]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_121, _toDisplayString(_ctx.provider.operationContactPhoneNumber), 1))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_122, [
        _createVNode("div", _hoisted_123, [
          _createVNode("h5", _hoisted_124, [
            _createVNode("button", _hoisted_125, _toDisplayString(_ctx.$t('providers.finance.title')), 1)
          ]),
          _hoisted_126
        ]),
        _createVNode("div", _hoisted_127, [
          _createVNode("div", _hoisted_128, [
            _createVNode("div", _hoisted_129, [
              _createVNode("div", _hoisted_130, [
                _createVNode("div", _hoisted_131, _toDisplayString(_ctx.$t('providers.finance.name')) + ":", 1),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_132, [
                      (_ctx.editMode)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "text",
                            class: "bookit-input form-control",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.provider.financeDepartmentFullName = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.provider.financeDepartmentFullName]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_133, _toDisplayString(_ctx.provider.financeDepartmentFullName), 1))
              ]),
              _createVNode("div", _hoisted_134, [
                _createVNode("div", _hoisted_135, [
                  _createVNode("div", _hoisted_136, _toDisplayString(_ctx.$t('providers.finance.email')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_137, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.provider.financeDepartmentEmail = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.financeDepartmentEmail]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_138, _toDisplayString(_ctx.provider.financeDepartmentEmail), 1))
                ]),
                _createVNode("div", _hoisted_139, [
                  _createVNode("div", _hoisted_140, _toDisplayString(_ctx.$t('providers.finance.phoneNumber')) + ":", 1),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_141, [
                        (_ctx.editMode)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "text",
                              class: "bookit-input form-control",
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.provider.financeDepartmentPhoneNumber = $event))
                            }, null, 512)), [
                              [_vModelText, _ctx.provider.financeDepartmentPhoneNumber]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_142, _toDisplayString(_ctx.provider.financeDepartmentPhoneNumber), 1))
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.provider.id)
        ? (_openBlock(), _createBlock("div", _hoisted_143, [
            _createVNode("div", _hoisted_144, [
              _createVNode("h5", _hoisted_145, [
                _createVNode("button", _hoisted_146, _toDisplayString(_ctx.$t('providers.profiles.title')), 1)
              ]),
              _hoisted_147
            ]),
            _createVNode("div", _hoisted_148, [
              _createVNode("div", _hoisted_149, [
                _createVNode("div", _hoisted_150, [
                  _createVNode(_component_Profiles, {
                    items: _ctx.provider.profiles,
                    providerId: _ctx.provider.id
                  }, null, 8, ["items", "providerId"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.provider.id)
        ? (_openBlock(), _createBlock("div", _hoisted_151, [
            _createVNode("div", _hoisted_152, [
              _createVNode("h5", _hoisted_153, [
                _createVNode("button", _hoisted_154, _toDisplayString(_ctx.$t('providers.users.title')), 1)
              ]),
              _hoisted_155
            ]),
            _createVNode("div", _hoisted_156, [
              _createVNode("div", _hoisted_157, [
                _createVNode("div", _hoisted_158, [
                  _createVNode(_component_Users, {
                    items: _ctx.provider.users,
                    providerId: _ctx.provider.id
                  }, null, 8, ["items", "providerId"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_159, [
        _createVNode("div", _hoisted_160, [
          _createVNode("h5", _hoisted_161, [
            _createVNode("button", _hoisted_162, _toDisplayString(_ctx.$t('providers.accounting.title')), 1)
          ]),
          _hoisted_163
        ]),
        _createVNode("div", _hoisted_164, [
          _createVNode("div", _hoisted_165, [
            _createVNode("div", _hoisted_166, [
              _createVNode(_component_Accounting, {
                settings: _ctx.provider.settings,
                commission: _ctx.provider.commissionPercent,
                "vat-type": _ctx.provider.vatType,
                "vat-percent": _ctx.provider.vatPercent,
                onUpdateCommission: _ctx.UpdateProviderCommission,
                onUpdateVatType: _ctx.UpdateVatType,
                onUpdateVat: _ctx.updateVat,
                editMode: _ctx.editMode
              }, null, 8, ["settings", "commission", "vat-type", "vat-percent", "onUpdateCommission", "onUpdateVatType", "onUpdateVat", "editMode"])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_167, [
        _createVNode("div", _hoisted_168, [
          _createVNode("h5", _hoisted_169, [
            _createVNode("button", _hoisted_170, _toDisplayString(_ctx.$t('providers.order-settings.title')), 1)
          ]),
          _hoisted_171
        ]),
        _createVNode("div", _hoisted_172, [
          _createVNode("div", _hoisted_173, [
            _createVNode("div", _hoisted_174, [
              _createVNode("div", _hoisted_175, [
                _createVNode("div", _hoisted_176, [
                  _createVNode("div", _hoisted_177, _toDisplayString(_ctx.$t('providers.accounting.paymentSystem')) + ":", 1),
                  (_ctx.cCardPaymentSystem)
                    ? (_openBlock(), _createBlock("div", _hoisted_178, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_179, [
                              (_ctx.editMode)
                                ? (_openBlock(), _createBlock(_component_Multiselect, {
                                    key: 0,
                                    label: "name",
                                    modelValue: _ctx.cCardPaymentSystem.value,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.cCardPaymentSystem.value = $event)),
                                    options: _ctx.providerPaymentSystems,
                                    canDeselect: true,
                                    valueProp: "id",
                                    searchable: false
                                  }, null, 8, ["modelValue", "options"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_180, _toDisplayString(_ctx.cCardPaymentSystem.value ? _ctx.paymentSystem[_ctx.cCardPaymentSystem.value] : ''), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_181, [
                  _createVNode("div", _hoisted_182, _toDisplayString(_ctx.$t('providers.accounting.paymentUsername')) + ":", 1),
                  (_ctx.cCardPaymentUsername)
                    ? (_openBlock(), _createBlock("div", _hoisted_183, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_184, [
                              (_ctx.editMode)
                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 0,
                                    type: "text",
                                    required: _ctx.cCardPaymentSystem.value ? true : false,
                                    class: "bookit-input form-control",
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.cCardPaymentUsername.value = $event))
                                  }, null, 8, ["required"])), [
                                    [_vModelText, _ctx.cCardPaymentUsername.value]
                                  ])
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_185, _toDisplayString(_ctx.cCardPaymentUsername.value), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_186, [
                      _createVNode("div", _hoisted_187, _toDisplayString(_ctx.$t('providers.accounting.paymentPassword')) + ":", 1),
                      (_ctx.cCardPaymentPassword)
                        ? (_openBlock(), _createBlock("div", _hoisted_188, [
                            (_ctx.editMode)
                              ? (_openBlock(), _createBlock("div", _hoisted_189, [
                                  (_ctx.editMode)
                                    ? _withDirectives((_openBlock(), _createBlock("input", {
                                        key: 0,
                                        type: "text",
                                        required: _ctx.cCardPaymentSystem.value ? true : false,
                                        class: "bookit-input form-control",
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.cCardPaymentPassword.value = $event))
                                      }, null, 8, ["required"])), [
                                        [_vModelText, _ctx.cCardPaymentPassword.value]
                                      ])
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_190, _toDisplayString(_ctx.cCardPaymentPassword.value), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", {
                  class: ["col-md-6", { order4: !_ctx.editMode }]
                }, [
                  _createVNode("div", _hoisted_191, _toDisplayString(_ctx.$t('providers.accounting.paymentTerminal')) + ":", 1),
                  (_ctx.cCardPaymentTerminal)
                    ? (_openBlock(), _createBlock("div", _hoisted_192, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_193, [
                              (_ctx.editMode)
                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 0,
                                    type: "text",
                                    required: _ctx.cCardPaymentSystem.value ? true : false,
                                    class: "bookit-input form-control",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.cCardPaymentTerminal.value = $event))
                                  }, null, 8, ["required"])), [
                                    [_vModelText, _ctx.cCardPaymentTerminal.value]
                                  ])
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_194, _toDisplayString(_ctx.cCardPaymentTerminal.value), 1))
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createVNode("div", {
                  class: _ctx.editMode ? 'col-12' : 'col-12 col-md-6 order3'
                }, [
                  _createVNode("div", _hoisted_195, _toDisplayString(_ctx.$t('providers.accounting.paymentUrl')) + ":", 1),
                  (_ctx.cCardPaymentUrl)
                    ? (_openBlock(), _createBlock("div", _hoisted_196, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_197, [
                              (_ctx.editMode)
                                ? _withDirectives((_openBlock(), _createBlock("input", {
                                    key: 0,
                                    type: "text",
                                    class: "bookit-input form-control",
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.cCardPaymentUrl.value = $event))
                                  }, null, 512)), [
                                    [_vModelText, _ctx.cCardPaymentUrl.value]
                                  ])
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_198, _toDisplayString(_ctx.cCardPaymentUrl.value), 1))
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createVNode("div", _hoisted_199, [
                  _createVNode("div", _hoisted_200, _toDisplayString(_ctx.$t('providers.accounting.maxPaymants')) + ":", 1),
                  (_ctx.cCardMaxCountPayments)
                    ? (_openBlock(), _createBlock("div", _hoisted_201, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_202, [
                              _createVNode(_component_InputNumber, {
                                class: "InputNumber-default",
                                modelValue: _ctx.cCardMaxCountPayments.value,
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.cCardMaxCountPayments.value = $event)),
                                min: 0,
                                max: 100,
                                allowEmpty: true,
                                format: false
                              }, null, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_203, _toDisplayString(_ctx.cCardMaxCountPayments.value), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_204, [
                  _createVNode("div", _hoisted_205, _toDisplayString(_ctx.$t('providers.accounting.quantityPaymentsCredit')) + ":", 1),
                  (_ctx.quantityPaymentsCredit)
                    ? (_openBlock(), _createBlock("div", _hoisted_206, [
                        (_ctx.editMode)
                          ? (_openBlock(), _createBlock("div", _hoisted_207, [
                              _createVNode(_component_InputNumber, {
                                class: "InputNumber-default",
                                modelValue: _ctx.quantityPaymentsCredit.value,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.quantityPaymentsCredit.value = $event)),
                                min: 0,
                                max: 100,
                                allowEmpty: true,
                                format: false
                              }, null, 8, ["modelValue"])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_208, _toDisplayString(_ctx.quantityPaymentsCredit.value), 1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_209, [
              _createVNode("div", _hoisted_210, [
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_211, _toDisplayString(_ctx.$t('provider.label.order-source-options')), 1))
                  : _createCommentVNode("", true),
                (_ctx.editMode)
                  ? (_openBlock(), _createBlock("div", _hoisted_212, [
                      _createVNode("button", {
                        type: "button",
                        class: "btn browse-photo browse-button green-button mb5 btn-add-source",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.addOption()))
                      }, [
                        _hoisted_213,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('providers.orderSettings.addOption')), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_214, _toDisplayString(_ctx.$t('editProviderPage.label.list-options')), 1)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provider.orderSourceOptions, (sourceOption, sourceOptionIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "col-12",
                    key: sourceOptionIndex
                  }, [
                    _createVNode("div", _hoisted_215, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("i", {
                              class: "icon-f icon-delete-cross fs-16 remove-provider-source-option",
                              onClick: ($event: any) => (_ctx.deleteSourceOption(sourceOptionIndex))
                            }, null, 8, ["onClick"]),
                            _createVNode("div", _hoisted_216, "Option " + _toDisplayString(sourceOptionIndex + 1), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "bookit-input form-control no-img",
                              "onUpdate:modelValue": ($event: any) => (sourceOption.text = $event),
                              maxlength: "30",
                              minlength: "1",
                              required: ""
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, sourceOption.text]
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_217, _toDisplayString(sourceOption.text), 1))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      (_ctx.provider.id)
        ? (_openBlock(), _createBlock("div", _hoisted_218, [
            _createVNode("div", _hoisted_219, [
              _createVNode("h5", _hoisted_220, [
                _createVNode("button", _hoisted_221, _toDisplayString(_ctx.$t('providers.notifications.title')), 1)
              ]),
              _hoisted_222
            ]),
            _createVNode("div", _hoisted_223, [
              _createVNode("div", _hoisted_224, [
                _createVNode("div", _hoisted_225, [
                  _createVNode(_component_NotificationsRestrictions, {
                    providerId: _ctx.provider.id,
                    restrictions: _ctx.provider.notificationsRestrictions,
                    editMode: _ctx.editMode
                  }, null, 8, ["providerId", "restrictions", "editMode"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_226, [
        _createVNode("div", _hoisted_227, [
          _createVNode("h5", _hoisted_228, [
            _createVNode("button", _hoisted_229, _toDisplayString(_ctx.$t('providers.subscription.title')), 1)
          ]),
          _hoisted_230
        ]),
        _createVNode("div", _hoisted_231, [
          _createVNode("div", _hoisted_232, [
            _createVNode("div", _hoisted_233, [
              _createVNode("div", _hoisted_234, [
                _createVNode("div", _hoisted_235, [
                  _createVNode("div", _hoisted_236, [
                    _createTextVNode(_toDisplayString(_ctx.$t('providers.subscription.type')) + ": ", 1),
                    _hoisted_237
                  ]),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_238, [
                        _createVNode(_component_Multiselect, {
                          required: "",
                          valueProp: "id",
                          label: "name",
                          class: { 'form-controll-multiselect': !_ctx.provider.subscriptionId },
                          options: _ctx.subscriptions,
                          modelValue: _ctx.provider.subscriptionId,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.provider.subscriptionId = $event))
                        }, null, 8, ["class", "options", "modelValue"]),
                        (!_ctx.provider.subscriptionId && _ctx.saveWas)
                          ? (_openBlock(), _createBlock("div", _hoisted_239, _toDisplayString(_ctx.$t('valid.isRequired')), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_240, _toDisplayString(_ctx.selectedSubscriptions.name), 1))
                ]),
                _createVNode("div", _hoisted_241, [
                  _createVNode("div", _hoisted_242, _toDisplayString(_ctx.$t('providers.subscription.productsQTY')) + ":", 1),
                  _createVNode("div", _hoisted_243, _toDisplayString(_ctx.selectedSubscriptions.availableProducts), 1)
                ]),
                (_ctx.provider.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_244, [
                      _createVNode("div", _hoisted_245, _toDisplayString(_ctx.$t('providers.subscription.createDate')) + ":", 1),
                      _createVNode("div", _hoisted_246, _toDisplayString(_ctx.formatLocalDateTime(_ctx.provider.createDate)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.provider.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_247, [
                      (_ctx.editMode)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("div", _hoisted_248, _toDisplayString(_ctx.$t('providers.subscription.active')), 1),
                            _createVNode("div", _hoisted_249, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                class: "toggle",
                                checked: _ctx.provider.active,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.provider.active = $event)),
                                onClick: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateProvider && _ctx.disactivateOrActivateProvider(...args)), ["stop"]))
                              }, null, 8, ["checked"]), [
                                [_vModelCheckbox, _ctx.provider.active]
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createBlock("div", _hoisted_250, [
                            (_ctx.provider.active)
                              ? (_openBlock(), _createBlock("span", _hoisted_251, "ACTIVE"))
                              : (_openBlock(), _createBlock("span", _hoisted_252, "NOT ACTIVE"))
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_253, [
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("div", _hoisted_254, _toDisplayString(_ctx.$t('providers.subscription.allow-crm')), 1),
                        _createVNode("div", _hoisted_255, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            class: "toggle",
                            checked: _ctx.provider.crmModuleEnabled,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.provider.crmModuleEnabled = $event)),
                            onClick: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disactivateOrActivateCrmModule && _ctx.disactivateOrActivateCrmModule(...args)), ["stop"]))
                          }, null, 8, ["checked"]), [
                            [_vModelCheckbox, _ctx.provider.crmModuleEnabled]
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createBlock("div", _hoisted_256, [
                        _createVNode("div", _hoisted_257, _toDisplayString(_ctx.$t('providers.subscription.allow-crm')), 1),
                        (_ctx.provider.crmModuleEnabled)
                          ? (_openBlock(), _createBlock("span", _hoisted_258, _toDisplayString(_ctx.$t('label.active')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_259, _toDisplayString(_ctx.$t('label.notactive')), 1))
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_260, [
                (_ctx.provider.active)
                  ? (_openBlock(), _createBlock("span", _hoisted_261, "ACTIVE"))
                  : (_openBlock(), _createBlock("span", _hoisted_262, "NOT ACTIVE"))
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_263, [
        _createVNode("div", _hoisted_264, [
          _createVNode("h5", _hoisted_265, [
            _createVNode("button", _hoisted_266, _toDisplayString(_ctx.$t('providers.cashier-station.title')), 1)
          ]),
          _hoisted_267
        ]),
        _createVNode("div", _hoisted_268, [
          _createVNode("div", _hoisted_269, [
            _createVNode("div", _hoisted_270, [
              _createVNode(_component_cashierStations, {
                editMode: _ctx.editMode,
                providerId: _ctx.provider.id,
                items: _ctx.provider.cashierStations,
                onAddStation: _ctx.addStation,
                onDeleteStation: _ctx.deleteStation,
                autoPrintReceiptProp: _ctx.provider.autoPrintReceipt,
                onChangeReceiptProviderSetting: _ctx.changeReceiptProviderSetting
              }, null, 8, ["editMode", "providerId", "items", "onAddStation", "onDeleteStation", "autoPrintReceiptProp", "onChangeReceiptProviderSetting"])
            ])
          ])
        ])
      ])
    ], 2)
  ]))
})